// styles
import styles from './error-message.module.scss'

export type ErrorMessageProps = {
	readonly message?: string | string[]
}

const ErrorMessage = ({ message }: ErrorMessageProps): JSX.Element => {
	const messageOutput: string[] = message
		? Array.isArray(message)
			? message
			: [message]
		: []

	return (
		<div className={styles.errorMessage}>
			{messageOutput.length > 0 && (
				<ul>
					{messageOutput.map((message, index) => (
						<li key={index}>
							<span className={styles.icon}></span>
							{message}
						</li>
					))}
				</ul>
			)}
		</div>
	)
}

export default ErrorMessage
